import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { observer } from 'mobx-react';
const useStyles = makeStyles()(theme => ({
    contentBlock: {
        position: 'relative',
        minHeight: '100%',
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    elidedBlock: {
        minHeight: '100%',
        boxSizing: 'border-box',
        backgroundColor: '#999',
        backgroundImage: 'repeating-linear-gradient(90deg, transparent, transparent 1px, rgba(255,255,255,.5) 1px, rgba(255,255,255,.5) 3px)',
    },
    interRegionPaddingBlock: {
        minHeight: '100%',
        backgroundColor: theme.palette.text.disabled,
    },
    boundaryPaddingBlock: {
        minHeight: '100%',
        backgroundColor: theme.palette.action.disabledBackground,
    },
}));
const ContentBlock = observer(function ({ block, children, }) {
    const { classes } = useStyles();
    const { widthPx } = block;
    return (React.createElement("div", { style: { width: widthPx }, className: classes.contentBlock }, children));
});
function ElidedBlock({ width }) {
    const { classes } = useStyles();
    return React.createElement("div", { className: classes.elidedBlock, style: { width } });
}
function InterRegionPaddingBlock({ boundary, width, style = {}, }) {
    const { classes } = useStyles();
    return (React.createElement("div", { style: {
            ...style,
            width,
        }, className: boundary
            ? classes.boundaryPaddingBlock
            : classes.interRegionPaddingBlock }));
}
export { ContentBlock, ElidedBlock, InterRegionPaddingBlock };
